import React from 'react';

import {
  Breadcrumb,
  Layout,
  Input,
  notification,
  Modal,
  Card,
  Button,
  Row,
  Col,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
// Graphql Imports
import getConfiguraciones from '../../../graphql/querys/configuracion/getConfiguraciones.graphql';
import updateConfiguracionPorId from '../../../graphql/mutations/configuracion/updateConfiguracionPorId.graphql';

import { connect } from 'react-redux';

@compose(
  graphql(getConfiguraciones, {
    options: {
      fetchPolicy: 'network-only',
    },
  }),
  graphql(updateConfiguracionPorId, {
    name: 'updateConfiguracionPorId',
    options: {
      refetchQueries: [{ query: getConfiguraciones }],
    },
  })
)
class ConfiguracionList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      jus: null,
    };
    //this.onDelete = this.onDelete.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.jus && nextProps.data.getConfiguraciones) {
      nextProps.data.getConfiguraciones.forEach(config => {
        if (config.clave === 'JUS') {
          this.setState({
            ...this.state,
            jus: config,
          });
        }
      });
    }
  }

  handleClick = () => {
    this.props.data.getConfiguraciones[0].valor;
    // console.log(this.props.data.getConfiguraciones);

    Modal.confirm({
      title: 'Esta seguro de que desea cambiar el valor?',
      content:
        'El valor del JUS que es ' +
        this.state.jus.valor +
        '$ será modificado por: ' +
        this.inputJUS.value +
        '$. Esta accion no podrá deshacerse',
      onOk: () => {
        this.props
          .updateConfiguracionPorId({
            variables: {
              _id: this.state.jus._id,
              configuracion: {
                clave: this.state.jus.clave,
                valor: this.inputJUS.value,
              },
            },
          })
          .then(res => {
            // console.log(res);
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'El JUS ahora es de: ' +
                res.data.updateConfiguracionPorId.valor +
                '$',
            });
          })
          .catch(err => {
            console.log('Error en el editar el valor del JUS');
            console.log(err);

            Modal.error({
              title: 'Error en la actualizacion de un valor de configuracion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };
  render() {
    if (this.state.loading || this.props.data.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Configuracion</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            //background: "#fff",
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Configuracion
          </h2>
          <br />
          <Card
            title="Valor del JUS"
            //extra={<a href="#">More</a>}
            style={{ width: 600 }}
          >
            <Row>
              <Col span={16}>
                <Input
                  placeholder="JUS"
                  //defaultValue={this.props.data.getConfiguraciones[0].valor}
                  defaultValue={this.state.jus.valor}
                  ref={input =>
                    (this.inputJUS = input !== null ? input.input : 0)
                  }
                  //ref={input => this.inputJUS = input.input}
                />
              </Col>
              <Col span={6} offset={2}>
                <Button onClick={() => this.handleClick()} type="primary">
                  Actualizar
                </Button>
              </Col>
            </Row>
          </Card>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = () => ({
  // actionsInscripciones: bindActionCreators(actionsInscripciones, dispatch),
  // actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(ConfiguracionList));
